module.exports = __webpack_public_path__ + "media/images/badges/stride/milestone-2_inactive-a6bb79bb00a42b0b4c34f7f9aa343199.svg";